import ContractsTopAgenciesGraph from "../Contracts.graphs/Contracts.graphs.topAgencies";
import ContractsTopCompetitionOptionsGraph from "../Contracts.graphs/Contracts.graphs.topCompetitionOptions";
import ContractsTopNaicsGraph from "../Contracts.graphs/Contracts.graphs.topNaics";
import ContractsTopPscGraph from "../Contracts.graphs/Contracts.graphs.topPsc";
import ContractsTopSetAsideGraph from "../Contracts.graphs/Contracts.graphs.topSetAside";
import ContractsTopStatesGraph from "../Contracts.graphs/Contracts.graphs.topStates";

const ANALYTICS_COMPONENT_MAP = {
    topAgencies: ContractsTopAgenciesGraph,
    topCompetitionOptions: ContractsTopCompetitionOptionsGraph,
    topNaics: ContractsTopNaicsGraph,
    topPsc: ContractsTopPscGraph,
    topSetAside: ContractsTopSetAsideGraph,
    topStates: ContractsTopStatesGraph,
}

export default ANALYTICS_COMPONENT_MAP;